// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivateContainer_wrapper__lOyMl","open":"PrivateContainer_open__A3toA"};